export const oimApiConfig = {
  apiBaseUrl: process.env.REACT_APP_API_URL,
  apiSubscriptionKey: process.env.REACT_APP_API_SUBSCRIPTION_KEY,
};
